import type { CategoryVariant } from './types';

/**
 * Category label → Badge color variant, per the 811/APWA utility-marking color
 * strategy (design review): categories with a clear 811 meaning take that color, and
 * everything else stays `grey` until the design ascribes more. The category is an
 * arbitrary top-level TOC section string from the catalog (not a fixed taxonomy), so any
 * label may show up — unmapped ones fall back to `grey` (see `categoryToVariant`).
 *
 * Notably grey: "Utilities" spans every 811 utility type (electric/gas/water/…), so it
 * takes no single 811 color.
 */
const CATEGORY_VARIANTS: Record<string, CategoryVariant> = {
  // 811 blue — potable water.
  Hydrology: 'blue',
  // 811 pink — temporary survey markings.
  Survey: 'pink',
  // 811 green — sewer/drainage (and the obvious association for the label).
  Environmental: 'green',
};

/** Resolve the pill color for a category label, defaulting to `grey` when unmapped. */
export function categoryToVariant(category: string): CategoryVariant {
  return CATEGORY_VARIANTS[category] ?? 'grey';
}
